import { useMutation } from '@tanstack/react-query'

import { bankAccountActivitiesWithdrawalReserve } from '@src/api'
import { DefaultApiBankAccountActivitiesWithdrawalReserveRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const usePostBankAccountActivitiesWithdrawalReserve = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (
      params: DefaultApiBankAccountActivitiesWithdrawalReserveRequest
    ) => bankAccountActivitiesWithdrawalReserve(axiosInstance, params),
  })
}
